import { PrivateRoutes, PublicRoutes } from '../../routes/navigation';
import { Route } from 'react-router-dom';
import ForgotPassword from '../../pages/Auth/ForgotPassword';
import ForgotSuccess from '../../pages/Auth/ForgotSuccess';
import { IonRouterOutlet, useIonRouter } from '@ionic/react';
import PsychologistListPage from 'src/pages/psychologist_list/PsychologistListPage';
import SpecialistProfile from 'src/pages/SpecialistProfile/SpecialistProfile';
import SchedulePage from 'src/pages/SchedulePage/SchedulePage';
import ChatsPage from 'src/pages/ChatsPage';
import ChatRoomPage from 'src/pages/ChatRoomPage';
import BookingSystemPage from '../../pages/BookingSystemPage';
import { SubscriptionControl } from 'src/pages/SubscriptionControl';
import { SubscriptionsPayment } from 'src/pages/SubscriptionsPayment';
import PaymentPage from 'src/pages/PaymentPage';
import VideoCall from 'src/pages/videoCall/VideoCall';
import Profile from '../../pages/Profile/Profile';
import ProfileName from '../../pages/Profile/SubPages/ProfileName';
import ProfileLastName from '../../pages/Profile/SubPages/ProfileLastName';
import ProfileEmail from '../../pages/Profile/SubPages/ProfileEmail';
import ProfilePassword from '../../pages/Profile/SubPages/ProfilePassword';
import ProfileCardsPage from '../../pages/ProfileCardsPage/ProfileCardsPage';
import RescheduleConfirmPage from '../../pages/BookingSystemPage/RescheduleConfirmPage';
import CancelSessionConfirmPage from '../../pages/BookingSystemPage/CancelSessionConfirmPage';
import { FavouriteSpecialists } from '../../pages/FavouriteSpecialists';
import OnBoarding from '../../pages/OnBoarding';
import { Redirect, RouteComponentProps } from 'react-router';
import SpecialistReviews from '../../pages/SpecialistReviews';
import SubscriptionsPlans from '../../pages/SubscriptionsPlans';
import { Auth, EmailSignInPage } from '../../pages/Auth';
import PasswordPage from '../../pages/Auth/PasswordPage';
import NamePage from '../../pages/Auth/NamePage';
import LastNamePage from '../../pages/Auth/LastNamePage';
import PromoCodesAndCoupons from '../../pages/PromoCodesAndCoupons';
import { ProfileSettings } from '../../pages/ProfileSettings';
import { SpecialistProfileBySlug } from '../../pages/SpecialistProfileBySlug';
import { OnBoardingFlowPage } from '../../pages/OnBoardingFlowPage';
import ProfileDoB from '../../pages/Profile/SubPages/ProfileDoB';
import ProfileTaxId from '../../pages/Profile/SubPages/ProfileTaxId';
import { UpdateContractPage } from '../../pages/UpdateContractPage';
import { SuccessTrialSessionPage } from '../../pages/SuccessTrialSessionPage';
import DoBPage from '../../pages/Auth/DoBPage';
import CountryPage from '../../pages/Auth/CountryPage';
import { NeedUpdatePersonalDataPage } from '../../pages/NeedUpdatePersonalDataPage';
import { NeedUpdatePersonalDataDOBPage } from '../../pages/NeedUpdatePersonalDataDOBPage';
import { NeedUpdatePersonalDataCountryOfLivingPage } from '../../pages/NeedUpdatePersonalDataCountryOfLivingPage';
import { NeedUpdatePersonalDataSuccessPage } from '../../pages/NeedUpdatePersonalDataSuccessPage';
import { CountryOfLivingPage } from '../../pages/CountryOfLivingPage';
import { NeedUpdatePersonalDataFirstNamePage } from '../../pages/NeedUpdatePersonalDataFirstNamePage';
import { NeedUpdatePersonalDataLastNamePage } from '../../pages/NeedUpdatePersonalDataLastNamePage';
import SpicialistListFilters from 'src/pages/SpicialistListFilters';
import NewVideoCall from 'src/pages/videoCall/NewVideoCall';
import { StreamChatChannelListPage } from 'src/pages/StreamChatChannelListPage';
import TabsBar from './TabsBar';
import { pageAnimation } from 'src/shared';
import { SessionDetail } from 'src/pages/Sessions/SessionDetail';
import { SessionPayments } from 'src/pages/Sessions/SessionPayments';
import JitsiVideoCall from 'src/pages/videoCall/JitsiVideoCall';

const MainTabs = () => {
  const navigation = useIonRouter();

  const rounting = (
    <IonRouterOutlet
      // is's hack to prevent animation on back button from booking system to specialist profile
      {...(navigation.routeInfo.lastPathname?.includes('tabs')
        ? { animated: true, animation: pageAnimation }
        : { animated: false })}
    >
      <Redirect exact path="/tabs" to={PrivateRoutes.PSYCHOLOGIST_LIST} />
      <Route exact path={PrivateRoutes.CONSULTATION} component={SchedulePage} />
      <Route exact path={PrivateRoutes.PSYCHOLOGIST_LIST} component={PsychologistListPage} />
      <Route exact path={PrivateRoutes.PSYCHOLOGIST_LIST_FILTERS} component={SpicialistListFilters} />
      <Route exact path={PrivateRoutes.CHATS} component={ChatsPage} />
      <Route exact path={PrivateRoutes.PSYCHOLOGIST_PROFILE_TAB} component={SpecialistProfile} />
      <Route exact path={PrivateRoutes.FAVOURITE_SPECIALISTS_TAB} component={FavouriteSpecialists} />
      <Route exact path={PrivateRoutes.PROFILE_SETTINGS_TAB} component={ProfileSettings} />
      <Route exact path={PrivateRoutes.SESSION_DETAIL} component={SessionDetail} />
      <Route exact path={PrivateRoutes.SESSION_PAYMENTS} component={SessionPayments} />
    </IonRouterOutlet>
  );

  return <TabsBar>{rounting}</TabsBar>;
};

export const Routing = () => {
  return (
    <IonRouterOutlet animated={false}>
      <Route exact path={PublicRoutes.AUTH} component={Auth} />
      <Route exact path={PublicRoutes.EMAIL_SIGN_IN} component={EmailSignInPage} />
      <Route exact path={PublicRoutes.PASSWORD} component={PasswordPage} />
      <Route exact path={PublicRoutes.NAME_SIGN_UP} component={NamePage} />
      <Route exact path={PublicRoutes.LAST_NAME_SIGN_UP} component={LastNamePage} />
      <Route exact path={PublicRoutes.DOB_SIGN_UP} component={DoBPage} />
      <Route exact path={PublicRoutes.COUNTRY_SIGN_UP} component={CountryPage} />
      <Route exact path={PublicRoutes.FORGOT_PASSWORD} component={ForgotPassword} />
      <Route exact path={PublicRoutes.FORGOT_PASSWORD_SUCCESS} component={ForgotSuccess} />
      <Route path={PublicRoutes.ON_BOARDING} component={OnBoarding} />
      <Route path={PublicRoutes.ON_BOARDING_FLOW} component={OnBoardingFlowPage} />

      <Route
        exact
        path={PrivateRoutes.PSYCHOLOGIST_PROFILE}
        component={(
          props: RouteComponentProps<{
            id: string;
          }>
        ) => <Redirect to={PrivateRoutes.PSYCHOLOGIST_PROFILE_TAB.replace(':id', props.match.params.id)} />}
      />
      <Route exact path={PrivateRoutes.CHAT_ROOM} component={ChatRoomPage} />
      <Route exact path={PrivateRoutes.BOOKING_SYSTEM} component={BookingSystemPage} />
      <Route exact path={PrivateRoutes.SUBSCRIPTION_BOOKING} component={BookingSystemPage} />

      <Route exact path={PrivateRoutes.SUBSCRIPTION} component={SubscriptionsPlans} />
      <Route exact path={PrivateRoutes.SUBSCRIPTION_CONTROL} component={SubscriptionControl} />
      <Route exact path={PrivateRoutes.SUBSCRIPTION_PAYMENT} component={SubscriptionsPayment} />
      <Route exact path={PrivateRoutes.PAYMENT} component={PaymentPage} />
      <Route exact path={PrivateRoutes.VIDEO_CHAT} component={VideoCall} />
      <Route exact path={PrivateRoutes.VIDEO_CHAT_STREAM} component={NewVideoCall} />
      <Route exact path={PrivateRoutes.VIDEO_CHAT_JITSI} component={JitsiVideoCall} />
      <Route exact path={PrivateRoutes.PROFILE_SETTINGS} component={ProfileSettings} />
      <Route exact path={PrivateRoutes.PROFILE_INFO} component={Profile} />
      <Route exact path={PrivateRoutes.PROFILE_NAME} component={ProfileName} />
      <Route exact path={PrivateRoutes.PROFILE_LAST_NAME} component={ProfileLastName} />
      <Route exact path={PrivateRoutes.PROFILE_DOB} component={ProfileDoB} />
      <Route exact path={PrivateRoutes.PROFILE_TAX_ID} component={ProfileTaxId} />
      <Route exact path={PrivateRoutes.PROFILE_EMAIL} component={ProfileEmail} />
      <Route exact path={PrivateRoutes.PROFILE_PASSWORD} component={ProfilePassword} />
      <Route exact path={PrivateRoutes.PROFILE_CARDS} component={ProfileCardsPage} />
      <Route exact path={PrivateRoutes.RESCHEDULE_CONFIRM} component={RescheduleConfirmPage} />
      <Route exact path={PrivateRoutes.CANCEL_SESSION_CONFIRM} component={CancelSessionConfirmPage} />
      <Route exact path={PrivateRoutes.FAVOURITE_SPECIALISTS} component={FavouriteSpecialists} />

      <Route exact path={PrivateRoutes.STREAM_CHAT_CONVERSATION_LIST} component={StreamChatChannelListPage} />

      <Route exact path={PrivateRoutes.UPDATE_CONTRACT_WARNING} component={UpdateContractPage} />
      <Route exact path={PrivateRoutes.SUCCESS_TRIAL_SESSIONS} component={SuccessTrialSessionPage} />

      <Route exact path={PrivateRoutes.NEED_UPDATE_PERSONAL_DATA} component={NeedUpdatePersonalDataPage} />
      <Route
        exact
        path={PrivateRoutes.NEED_UPDATE_PERSONAL_DATA_FIRST_NAME}
        component={NeedUpdatePersonalDataFirstNamePage}
      />
      <Route
        exact
        path={PrivateRoutes.NEED_UPDATE_PERSONAL_DATA_LAST_NAME}
        component={NeedUpdatePersonalDataLastNamePage}
      />
      <Route exact path={PrivateRoutes.NEED_UPDATE_PERSONAL_DATA_DOB} component={NeedUpdatePersonalDataDOBPage} />
      <Route
        exact
        path={PrivateRoutes.NEED_UPDATE_PERSONAL_DATA_COUNTRY_OF_LIVING}
        component={NeedUpdatePersonalDataCountryOfLivingPage}
      />
      <Route
        exact
        path={PrivateRoutes.NEED_UPDATE_PERSONAL_DATA_SUCCESS}
        component={NeedUpdatePersonalDataSuccessPage}
      />
      <Route exact path={PrivateRoutes.PROFILE_COUNTRY_OF_LIVING} component={CountryOfLivingPage} />
      <Route exact path={PrivateRoutes.SPECIALIST_REVIEWS} component={SpecialistReviews} />
      <Route exact path={PrivateRoutes.DISCOUNTS} component={PromoCodesAndCoupons} />

      <Route exact path={PublicRoutes.SPECIALIST_BY_SLUG} component={SpecialistProfileBySlug} />

      <Route exact path={'/'} component={Auth} />

      <Route path="/tabs" component={MainTabs} />

      <Route render={() => <Redirect to={PrivateRoutes.PSYCHOLOGIST_LIST} />} />
    </IonRouterOutlet>
  );
};
